import React, { useRef } from 'react'
import { Popover } from 'antd'
import { getClassNames } from '../../../../_utils/classnames'
import { JourneyBuilderMode } from '../../enums'
import { AddStepType } from '../../types/journey-nodes'
import type { IActionStep, IDelayStep } from '@pushly/models/lib/structs/journeys'
import { CopyTypes } from '../../types/journey-context'
import { EdgeAction } from '../custom-edge/edge-action'
import { AddStepPanel } from '../custom-edge/add-step-panel'
import { CatalogItemType } from '@pushly/models/lib/enums/catalogs/catalog-item-type'

export interface EdgeActionPopoverProps {
    addButtonX: number
    addButtonY: number
    edgeActionOptions: AddStepType[]
    showEdgeActions: boolean
    setShowEdgeActions: (show: boolean) => void
    handleAddNode: (
        stepType: AddStepType,
        addConfig?: { override?: IActionStep | IDelayStep; overrideType?: CopyTypes; skipOpenEditor?: boolean },
    ) => void
    mode: JourneyBuilderMode
    itemType?: CatalogItemType
}

export const EdgeActionPopover = ({
    addButtonX,
    addButtonY,
    edgeActionOptions,
    showEdgeActions,
    setShowEdgeActions,
    handleAddNode,
    mode,
    itemType,
}: EdgeActionPopoverProps) => {
    return (
        <div
            className={getClassNames(null, 'journey-edge-custom', {
                open: showEdgeActions,
                interactive: mode !== JourneyBuilderMode.READONLY,
            })}
            // position + top/left pin the overlay's origin to the EdgeLabelRenderer
            // container corner so the transform below is the SOLE positioner. Without
            // an explicit top/left, an absolutely-positioned EdgeLabelRenderer child
            // keeps its normal-flow static offset (it stacks per sibling), so the same
            // transform renders at different screen Ys across edges — that was the
            // entire (+) button drift / per-lane ramp (NS-2599).
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                transform: `translate(-50%, -50%) translate(${addButtonX}px, ${addButtonY}px)`,
            }}
            onClick={(ev) => ev.stopPropagation()}
        >
            <div
                className={getClassNames('journey-edge-actions', {
                    open: showEdgeActions,
                })}
            >
                <Popover
                    open={showEdgeActions}
                    onOpenChange={setShowEdgeActions}
                    trigger="click"
                    placement="rightTop"
                    align={{ offset: [10, -5] }}
                    destroyOnHidden
                    style={{
                        zIndex: 1000,
                    }}
                    content={
                        <div onClick={(ev) => ev.stopPropagation()}>
                            <AddStepPanel options={edgeActionOptions} onSelect={handleAddNode} itemType={itemType} />
                        </div>
                    }
                >
                    <div style={{ display: 'inline-block' }}>
                        <EdgeAction visible={showEdgeActions} />
                    </div>
                </Popover>
            </div>
        </div>
    )
}
